import { ReceiptsResumeFinalComponent } from './resume-final/resume-final.component';
import { ReceiptsTableComponent } from './receipts-table/receipts-table.component';
import { SpecialFilterComponent } from './special-filter/special-filter.component';
import { MonthFilterComponent } from './month-filter/month-filter.component';
import { ReceiptsComponent } from './receipts.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatDatepickerModule, MatButtonModule, MatCardModule, MatProgressSpinnerModule } from '@angular/material';
import { SlickModule } from 'ngx-slick';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReceiptsService } from './receipts.service';
import { RechargeResumeFinalComponent } from './recharge-resume-final/recharge-resume-final.component';
import { ConcludedReceiptComponent } from './concluded-receipt/concluded-receipt.component';
import { TransactionHandlerService } from '../transfers-other-banks/transfer-response/services/transaction-handler.service';
import { PrintReceiptComponent } from './print-receipt/print-receipt.component';
import { PaymentReceiptsService } from '../payment-securities/services/payment-receipt.service';
import { BankslipReceiptComponent } from './bankslip-receipt/bankslip-receipt.component';
import { TransferReceiptComponent } from './transfer-receipt/transfer-receipt.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		MatTableModule,
		SlickModule.forRoot(),
		MatDatepickerModule,
		MatButtonModule,
		FormsModule,
		ReactiveFormsModule,
		MatProgressSpinnerModule,
		MatCardModule,
	],
	declarations: [
		ReceiptsComponent,
		MonthFilterComponent,
		SpecialFilterComponent,
		ReceiptsTableComponent,
		ReceiptsResumeFinalComponent,
		RechargeResumeFinalComponent,
		ConcludedReceiptComponent,
		PrintReceiptComponent,
		BankslipReceiptComponent,
		TransferReceiptComponent
	],
	exports: [
		PrintReceiptComponent
	],
	providers: [ReceiptsService, TransactionHandlerService, PaymentReceiptsService]
})
export class ReceiptsModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/receipts/receipts.module.ts